import { SkeletonSpinnerCentered } from '@civilgrid/ui/SkeletonLoader';
import { useParams } from '@tanstack/react-router';
import { useAsync } from 'react-use';
import { getProjectSummary } from '~/api/projects2';
import type { ProjectDetailsParams } from '..';
import Section from './Section';
import UpgradeButton from './UpgradeButton';

export default function GeotechnicalComponent() {
  const { projectId } = useParams({ strict: false }) as ProjectDetailsParams;
  const res = useAsync(async () => {
    return await getProjectSummary<{
      geotechStudies: number;
      usgsMaps: {
        count: number;
        years: number;
      };
    }>(projectId, 'geotechnical');
  }, [projectId]);

  if (res.error) {
    console.error(res.error);
    return null;
  }

  return (
    <Section icon="🪨" title="Geotechnical">
      {res.loading ? (
        <SkeletonSpinnerCentered />
      ) : (
        <div className="space-y-2">
          <div className="text-sm">
            Explore <span className="font-semibold">{res.value!.geotechStudies}</span> Well Completion and Boring Logs,
            plus <span className="font-semibold">{res.value!.usgsMaps.count}</span> historical USGS Maps & Studies
            spanning from {res.value!.usgsMaps.years}. The following datasets are also available
          </div>

          <div className="my-2 grid grid-cols-2 text-sm">
            <div>Detailed Soil report</div>
            <div>Flood Hazard Zones</div>
            <div>Groundwater Stations</div>
            <div>Groundwater Elevations</div>
            <div>Landslide Areas</div>
            <div>Liquefaction Zone</div>
            <div>Wells</div>
            <div>Fault Hazard</div>
          </div>

          <UpgradeButton>View Geotechnical</UpgradeButton>
        </div>
      )}
    </Section>
  );
}
